import { ComedySection } from './ComedyShared';

const TABS = [
  {
    name: 'Dashboard',
    purpose: 'Ogólny stan studio: kanały, profile, materiały, wypowiedzi, scenariusze, produkcje, publikacje, błędy, koszty AI i render farm.',
    steps: ['Sprawdź liczbę błędów i koszt AI.', 'Kliknij „Otwórz” przy kanale, aby przejść do jego pracy.', 'Render farm pokazuje stan VPS; brak heartbeatu oznacza, że usługa renderera nie działa.'],
  },
  {
    name: 'Kanały tematyczne',
    purpose: 'Tworzenie i konfiguracja niezależnych kanałów: język, temat, humor, długość, godziny, budżet, prawa, napisy, status.',
    steps: ['Kliknij „+ Nowy kanał”, wypełnij formularz i zapisz.', 'Po zapisaniu wybierz kanał — pod formularzem pojawi się sekcja profili social media.', 'Zaznacz kilka profili (FB/IG/YT/TikTok) i kliknij „Przypisz zaznaczone”.', 'Aby uruchomić kanał, ustaw Status = ACTIVE i zapisz.'],
  },
  {
    name: 'Research AI',
    purpose: 'Odkrywanie materiałów video/audio i przeglądanie wyników. Tu oceniasz prawa i zlecasz pobranie dozwolonego materiału.',
    steps: ['Kliknij „Uruchom research” (albo wejdź w Źródła i przetestuj konkretne źródło).', 'Filtruj po statusie/prawach; kliknij „Oceń prawa”, aby wpisać podstawę wykorzystania.', 'Dla CLEARED kliknij „Pobierz” — plik trafi na VPS/R2.', 'Materiał bez CLEARED zostaje tylko w researchu.'],
  },
  {
    name: 'Źródła materiałów',
    purpose: 'Konfiguracja źródeł: YouTube Search, kanały YouTube, RSS/Atom, Wikimedia Commons, Internet Archive, ręczne.',
    steps: ['Dodaj źródło i ustaw politykę licencji.', 'Kliknij „Test”, aby sprawdzić, ile wyników zwraca.', 'Dla YouTube wymagany jest YOUTUBE_API_KEY w Workerze.', 'Dla własnych materiałów używaj źródła ręcznego lub wgraj plik w Bibliotece.'],
  },
  {
    name: 'Biblioteka wypowiedzi',
    purpose: 'Transkrypcje, segmenty zdań, wyszukiwanie semantyczne i ręczna korekta tekstu po ASR.',
    steps: ['Wgraj własny/licencjonowany plik lub pobierz CLEARED materiał z researchu.', 'Kliknij „Transkrybuj” — lokalny whisper.cpp przetworzy plik na VPS.', 'Szukaj po znaczeniu, np. „nie mam pojęcia, co robię”.', 'Kliknij „Popraw”, jeśli ASR pomylił słowa — cytaty muszą odpowiadać nagraniu.'],
  },
  {
    name: 'Scenariusze AI',
    purpose: 'Lista wygenerowanych wariantów, oceny humoru/ryzyka i zatwierdzanie do produkcji.',
    steps: ['Filtruj po statusie REVIEW/DRAFT.', 'Otwórz scenariusz, sprawdź hook, puentę i oś czasu.', 'Zatwierdź lub odrzuć; przy flagach ryzyka potwierdź ręczną ocenę.', 'Zatwierdzony scenariusz trafia do produkcji.'],
  },
  {
    name: 'Comedy Director',
    purpose: 'Generowanie scenariuszy: HYBRID AUTO, STORY FIRST, FOOTAGE FIRST albo własny szkic tekstu.',
    steps: ['Wybierz tryb i liczbę wariantów.', 'Opcjonalnie wpisz temat, docelową liczbę słów i materiałów (np. 20 słów → 10 wycinków).', 'Możesz wkleić własny szkic scenariusza — system dopasuje realne wypowiedzi, nie wymyśli cytatów.', 'Zatwierdź scenariusz i uruchom produkcję.'],
  },
  {
    name: 'Video Studio',
    purpose: 'Podgląd gotowych renderów, QA, zatwierdzanie filmu i przygotowanie publikacji.',
    steps: ['Poczekaj na status READY.', 'Obejrzyj film i sprawdź QA (format, audio, napisy, prawa, oznaczenie).', 'Kliknij „Zatwierdź film”.', 'Wybierz platformy i kliknij „Przygotuj publikacje”.'],
  },
  {
    name: 'Kolejka produkcji',
    purpose: 'Aktywne rendery, błędy i ręczne uruchomienie cyklu automatyzacji.',
    steps: ['Sprawdź postęp i błędy.', 'Kliknij „Uruchom cykl teraz”, aby wykonać bounded research → scenariusz → render.', 'Błędy renderu wymagają sprawdzenia VPS lub scenariusza.'],
  },
  {
    name: 'Harmonogram',
    purpose: 'Planowanie publikacji na konkretne profile i terminy, z limitami kanału i profilu.',
    steps: ['Wybierz zatwierdzoną produkcję.', 'Zaznacz platformy i opcjonalnie konkretny termin.', 'Kliknij „Przygotuj i zaplanuj”.', 'System pilnuje limitów dziennych i odstępu ±15 min.'],
  },
  {
    name: 'Publikacje',
    purpose: 'Status publikacji per profil, linki publiczne, błędy i synchronizacja wyników.',
    steps: ['Filtruj SCHEDULED/SENT/FAILED.', 'Kliknij „Synchronizuj wyniki”, aby odświeżyć status z publishera.', 'Anuluj niewysłane publikacje, jeśli zmieniasz plan.'],
  },
  {
    name: 'Analytics',
    purpose: 'Rzeczywiste metryki platform i wskazówki oparte na wynikach.',
    steps: ['Wybierz zakres 7/28/90 dni.', 'Kliknij „Pobierz metryki”.', 'Sprawdź platformy, formaty, długości i godziny.', 'Brak danych oznacza brak API/danych — nie jest uzupełniany estymacją.'],
  },
  {
    name: 'Ustawienia',
    purpose: 'Globalna konfiguracja modułu: włączenie, limity, bramki AUTOPILOT, treść oznaczenia parodii.',
    steps: ['Włącz „Moduł aktywny”, jeśli chcesz automatyczny cykl.', 'Ustaw limity renderów/scenariuszy.', 'Nie wyłączaj wymagań praw/QA, jeśli zamierzasz używać AUTOPILOT.', 'Zapisz — zmiany mają kontrolę wersji.'],
  },
];

export function ComedyHelpPanel() {
  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <ComedySection title="Pomoc — jak korzystać z Comedy Studio" description="Krótki przewodnik po zakładkach, źródłach video, prawach i typowych problemach.">
        <div className="alert alert--info">
          <strong>Najkrótsza ścieżka:</strong> Kanały → utwórz kanał → przypisz profile social → Źródła/Research → wgraj lub pobierz dozwolony materiał → Transkrypcja → Biblioteka → Scenariusze/Director → Video Studio → QA → Harmonogram → Publikacje → Analytics.
        </div>
        <ol style={{ margin: 0, paddingLeft: 20, lineHeight: 1.9 }}>
          <li><strong>Kanał</strong>: ustaw język, tematykę, styl humoru, długość i godziny.</li>
          <li><strong>Profile social</strong>: przypisz istniejące konta (można kilka naraz).</li>
          <li><strong>Materiał</strong>: research albo własny upload; prawa muszą być CLEARED, żeby wejść do produkcji.</li>
          <li><strong>Transkrypcja</strong>: lokalny whisper.cpp na VPS tworzy słowa i zdania z timestampami.</li>
          <li><strong>Scenariusz</strong>: Director wybiera tylko realne wypowiedzi; własny szkic jest mapowany na bibliotekę.</li>
          <li><strong>Render + QA</strong>: Remotion/FFmpeg, napisy, efekty, pomiar audio i czarnych klatek.</li>
          <li><strong>Publikacja</strong>: zatwierdzenie → przygotowanie opisów per platforma → harmonogram → publisher.</li>
        </ol>
      </ComedySection>

      <ComedySection title="Co robi każda zakładka" description="Kliknij zakładkę, aby rozwinąć opis i kroki.">
        <div style={{ display: 'grid', gap: 8 }}>
          {TABS.map((tab) => (
            <details key={tab.name} style={{ border: '1px solid var(--border)', borderRadius: 8, padding: '10px 12px', background: 'var(--surface-2)' }}>
              <summary style={{ cursor: 'pointer', fontWeight: 700 }}>{tab.name}</summary>
              <div style={{ marginTop: 8, lineHeight: 1.6 }}>
                <div>{tab.purpose}</div>
                <ol style={{ margin: '8px 0 0', paddingLeft: 20 }}>
                  {tab.steps.map((step) => <li key={step}>{step}</li>)}
                </ol>
              </div>
            </details>
          ))}
        </div>
      </ComedySection>

      <ComedySection title="Skąd brać video do kabaretu" description="YouTube służy do wyszukiwania, ale nie każde video można pobrać i opublikować.">
        <div className="table-wrap" style={{ overflowX: 'auto' }}>
          <table className="table">
            <thead><tr><th>Źródło</th><th>Do czego</th><th>Wymagania</th></tr></thead>
            <tbody>
              <tr><td>YouTube Search</td><td>Odkrywanie wywiadów, skeczy, wpadke, stand-upu.</td><td><code>YOUTUBE_API_KEY</code> w Workerze. Zwraca metadane; nie pobiera filmu.</td></tr>
              <tr><td>Własny upload</td><td>Twoje nagrania lub materiał, do którego masz zgodę.</td><td>Plik video/audio + deklaracja praw w Bibliotece.</td></tr>
              <tr><td>Internet Archive</td><td>Public domain / CC video.</td><td>Bez klucza; prawa sprawdzane per plik. Włącz źródło i przetestuj.</td></tr>
              <tr><td>Wikimedia Commons</td><td>CC/PD video.</td><td>Bez klucza; wymagany poprawny User-Agent (wdrożony).</td></tr>
              <tr><td>RSS/Atom</td><td>Podcasty i kanały z feedem.</td><td>URL feedu; często tylko metadane — plik trzeba wgrać lub wskazać bezpośredni URL.</td></tr>
            </tbody>
          </table>
        </div>
        <div className="alert alert--warning" style={{ marginTop: 12 }}>
          Publiczna dostępność filmu na YouTube nie jest zgodą na pobranie i ponowną publikację. Dla cudzego kabaretu potrzebujesz zgody twórcy (nawet krótkiej wiadomości e-mail/DM) i wpisujesz ją jako LICENSED z notatką. Własne nagrania oznaczasz jako OWNED. Bez tego system zatrzyma produkcję — to chroni kanał przed strike’ami.
        </div>
      </ComedySection>

      <ComedySection title="Jak działa „20 słów → 10 materiałów”" description="W Comedy Director możesz podać docelową liczbę słów i wycinków albo wkleić własny szkic.">
        <ol style={{ margin: 0, paddingLeft: 20, lineHeight: 1.9 }}>
          <li>Wpisujesz np. 20 słów i 10 materiałów (albo sam tekst).</li>
          <li>System dzieli tekst na 10 krótkich fragmentów.</li>
          <li>Dla każdego fragmentu wyszukuje w bibliotece najlepiej pasującą <strong>realną wypowiedź</strong> (całe zdanie/segment), preferując różne źródła i mówców.</li>
          <li>Z wybranych segmentów powstaje 10 wycinków w kolejności scenariusza; każdy ma własny timestamp.</li>
          <li>Napisy i QA korzystają z rzeczywistego tekstu wycinka. System nie skleja słowo-po-słowie z różnych nagrań i nie wymyśla cytatów.</li>
        </ol>
        <div className="alert alert--info" style={{ marginTop: 12 }}>
          To nie jest synteza nowych zdań z pojedynczych słów. Jeśli potrzebujesz dosłownego montażu słowo-po-słowie, to osobny, bardziej ryzykowny tryb — wymaga wyraźnego oznaczenia parodii i ręcznej kontroli jakości.
        </div>
      </ComedySection>

      <ComedySection title="Prawa — co wpisać" description="Bramka praw jest obowiązkowa dla automatycznej produkcji i publikacji.">
        <div className="table-wrap" style={{ overflowX: 'auto' }}>
          <table className="table">
            <thead><tr><th>Pole</th><th>Znaczenie</th></tr></thead>
            <tbody>
              <tr><td><code>OWNED</code></td><td>Twoje własne nagranie. Zaznacz prawa komercyjne i zgodę na przeróbki.</td></tr>
              <tr><td><code>LICENSED</code></td><td>Masz zgodę/umowę twórcy. W notatce wpisz kto, kiedy i na co wyraził zgodę.</td></tr>
              <tr><td><code>CREATIVE_COMMONS</code></td><td>Tylko CC BY / CC0. CC BY-SA, -NC, -ND wymagają osobnej decyzji.</td></tr>
              <tr><td><code>PUBLIC_DOMAIN</code></td><td>Domena publiczna; zachowaj atrybucję, jeśli wymagana.</td></tr>
              <tr><td><code>CLEARED</code></td><td>Dopiero ten status pozwala na produkcję. Wymaga podstawy, praw komercyjnych, zgody na przeróbki i ewentualnej atrybucji.</td></tr>
            </tbody>
          </table>
        </div>
      </ComedySection>

      <ComedySection title="Typowe problemy" description="Najczęstsze komunikaty i co zrobić.">
        <div className="table-wrap" style={{ overflowX: 'auto' }}>
          <table className="table">
            <thead><tr><th>Problem</th><th>Rozwiązanie</th></tr></thead>
            <tbody>
              <tr><td>„YOUTUBE_API_KEY is not configured”</td><td>Dodaj sekret Workera: <code>npx wrangler secret put YOUTUBE_API_KEY --config apps/api/wrangler.jsonc</code>, potem ponów test źródła. Bez klucza YouTube Search nie działa.</td></tr>
              <tr><td>Wikimedia HTTP 403</td><td>Naprawiony User-Agent; po wdrożeniu API ponów test. Jeśli nadal 403, sprawdź egress Cloudflare.</td></tr>
              <tr><td>Brak kont w „Dodaj profil”</td><td>Konto musi być ACTIVE w Social Accounts, mieć profil Sociamonials (FB/IG/TikTok) lub token YouTube. Odepnij je najpierw z innego kanału Comedy.</td></tr>
              <tr><td>„Biblioteka ma za mało wypowiedzi”</td><td>Wgraj/pobierz więcej materiałów i uruchom transkrypcję. Minimum 4 segmenty (2 dla trybu ze szkicem).</td></tr>
              <tr><td>„whisper.cpp is unavailable”</td><td>Na VPS uruchom <code>bash scripts/whisper-cpp.sh install</code>, potem zrestartuj <code>kontentowo-video-renderer.service</code>.</td></tr>
              <tr><td>QA FAIL</td><td>Sprawdź kryteria: prawa, format 1080×1920, długość, LUFS, napisy, czarne klatki, oznaczenie parodii. Napraw scenariusz/montaż i wyrenderuj ponownie.</td></tr>
              <tr><td>Brak publikacji</td><td>Film musi być APPROVED, profile przypisane, publikacje przygotowane i zaplanowane, a <code>PUBLISH_LIVE</code> musi zawierać platformę.</td></tr>
              <tr><td>AUTOPILOT nic nie robi</td><td>Włącz moduł globalnie, ustaw kanał ACTIVE, tryb AUTOPILOT, <code>requireManualApproval=false</code>, przypisz profile i zapewnij CLEARED materiały.</td></tr>
            </tbody>
          </table>
        </div>
      </ComedySection>

      <ComedySection title="Bezpieczeństwo i zgodność" description="Zasady, których system pilnuje.">
        <ul style={{ margin: 0, paddingLeft: 20, lineHeight: 1.9 }}>
          <li>Nie pobiera filmów z YouTube — tylko metadane; pliki muszą pochodzić z legalnego źródła lub od Ciebie.</li>
          <li>Nie usuwa znaków wodnych, nie obchodzi DRM i nie publikuje materiałów bez CLEARED.</li>
          <li>Każdy film ma wypalone oznaczenie „PARODIA · FIKCYJNY MONTAŻ” i informację w opisie.</li>
          <li>Nie przypisuje realnym osobom przestępstw, prywatnych wyznań ani fałszywych deklaracji; ryzykowne scenariusze wymagają ręcznego potwierdzenia.</li>
          <li>Nie publikuje bez zatwierdzenia w SEMI-AUTO; AUTOPILOT wymaga świadomego włączenia i QA PASS.</li>
        </ul>
      </ComedySection>

      <ComedySection title="Pełna dokumentacja" description="Dokument techniczny w repozytorium.">
        <code>docs/COMEDY_STUDIO.md</code> — architektura, endpointy, model danych, migracja, konfiguracja, ograniczenia i testy.
      </ComedySection>
    </div>
  );
}
